import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import GenericAccessories from './GenericAccessories';
import useStyles from './styles';
import Loader from '../../../commons/Loader';

export default function AccessorySection({
  accessories,
  cornerPostAccessories,
  cornerAccessories,
  inputData,
}) {
  const classes = useStyles;
  return (
    <Box className={classes.accessoriesWrapper}>
      <GenericAccessories accessoryList={accessories} />
      {inputData.corners > 0
        && (
          <>
            <GenericAccessories accessoryList={cornerAccessories} isCorner />
            <GenericAccessories accessoryList={cornerPostAccessories} isCorner />
          </>
        )}
      <Loader target="addAccessory" size={32} backdrop />
    </Box>
  );
}

AccessorySection.propTypes = {
  accessories: PropTypes.objectOf(PropTypes.any).isRequired,
  cornerPostAccessories: PropTypes.objectOf(PropTypes.any).isRequired,
  cornerAccessories: PropTypes.objectOf(PropTypes.any).isRequired,
  inputData: PropTypes.objectOf(PropTypes.any).isRequired,
};
